import { Box } from '@material-ui/core';
import React from 'react';
import { ThemeProvider } from '../../../../theme-config/ThemeProvider';
import HelpCentreBanner from './HelpCentreBanner';
import styles from './style';

/**
 * @name HelpCentreBannerContainer
 * @param {*} props - Strapi Data
 * @returns {JSX.Element} - Renders Banner component
 */
const HelpCentreBannerContainer = props => {
    const classes = styles();
    return (
        <>
            <ThemeProvider palette={props?.cmsData?.Banner_theme?.theme}>
                <Box className={classes.helpContainer}>
                    <HelpCentreBanner cmsData={props?.cmsData} handleAction={props?.handleAction} />
                </Box>
            </ThemeProvider>
        </>
    );
};

HelpCentreBannerContainer.displayName = 'HelpCentreBannerContainer';
export default HelpCentreBannerContainer;
